import { render } from "./ActivityDrawer.vue?vue&type=template&id=123c2c3a"
import script from "./ActivityDrawer.vue?vue&type=script&lang=ts"
export * from "./ActivityDrawer.vue?vue&type=script&lang=ts"
script.render = render

export default script